<p-dialog [style]="{ width: '36rem' }" [breakpoints]="{ '575px': '95vw' }"
    [(visible)]="visibility" [closable]="false" [modal]="true" [draggable]="false" [dismissableMask]="true">

  <ng-template #header>
    <div class="ef-dialog-header">
      <span class="ef-dialog-title">{{ isEditMode ? 'Edit group' : 'New customer group' }}</span>
      <button class="ef-close-btn" type="button" (click)="cancel()"><i class="fa-solid fa-xmark"></i></button>
    </div>
  </ng-template>

  <form [formGroup]="form" class="ef-form" (ngSubmit)="submit()">

    <div class="ef-field mt-2">
      <label class="ef-label" for="grp-name">Group name</label>
      <input id="grp-name" formControlName="name" type="text" pInputText placeholder="e.g. Emirates Platinum" class="ef-input" />
      @if ((form.get('name')?.touched || isSubmitted) && form.get('name')?.errors?.['required']) {
        <small class="ef-error">Required</small>
      }
      @if (nameError) {
        <small class="ef-error">{{ nameError }}</small>
      }
    </div>

    <div class="ef-field">
      <label class="ef-label" for="grp-desc">Description <span class="ef-optional">(optional)</span></label>
      <textarea id="grp-desc" formControlName="description" pTextarea
        placeholder="Short description of this group" class="ef-input ef-textarea" rows="2" [autoResize]="true"></textarea>
    </div>

    <div class="ef-field">
      <span class="ef-label">Color @if (isEditMode) { &amp; Status }</span>
      <div class="ef-color-status-row">
        <div class="ef-color-row">
          <input id="grp-color" formControlName="color" type="color" class="ef-color-input" />
          <span class="ef-color-value">{{ form.get('color')?.value }}</span>
        </div>
        @if (isEditMode) {
        <div class="ef-status-toggle">
          <button type="button" class="ef-status-btn" [class.active]="form.get('status')?.value === 'ACTIVE'"
            (click)="form.get('status')?.setValue('ACTIVE')">Active</button>
          <button type="button" class="ef-status-btn" [class.active]="form.get('status')?.value === 'INACTIVE'"
            (click)="form.get('status')?.setValue('INACTIVE')">Inactive</button>
        </div>
        }
      </div>
    </div>

    <!-- Badge (edit mode or create) -->
    <div class="ef-field">
      <span class="ef-label">Badge image <span class="ef-optional">(optional · jpg, png, gif, webp · max 20 MB)</span></span>

      <!-- Current badge from server -->
      @if (currentBadgeUrl && !badgePreview) {
        <div class="ef-badge-preview">
          <img [src]="currentBadgeUrl" alt="Badge" class="ef-badge-img" />
          <button type="button" class="ef-badge-remove" (click)="deleteBadge()" [disabled]="badgeLoading" title="Remove badge">
            @if (badgeLoading) { <i class="fa-solid fa-spinner fa-spin"></i> }
            @else { <i class="fa-solid fa-trash"></i> }
          </button>
          <label class="ef-badge-upload-btn" for="grp-badge">
            <i class="fa-solid fa-arrow-up-from-bracket"></i> Replace
            <input id="grp-badge" type="file" accept="image/jpeg,image/png,image/gif,image/webp" (change)="onBadgeFileChange($event)" hidden />
          </label>
        </div>
      }

      <!-- New file selected locally -->
      @if (badgePreview) {
        <div class="ef-badge-preview">
          <img [src]="badgePreview" alt="Preview" class="ef-badge-img" />
          <button type="button" class="ef-badge-remove" (click)="removeBadgeSelection()" title="Remove selection">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      }

      @if (!currentBadgeUrl && !badgePreview) {
        <label class="ef-badge-upload-btn" for="grp-badge">
          <i class="fa-solid fa-arrow-up-from-bracket"></i> Upload badge
          <input id="grp-badge" type="file" accept="image/jpeg,image/png,image/gif,image/webp" (change)="onBadgeFileChange($event)" hidden />
        </label>
      }

      @if (badgeError) {
        <small class="ef-error">{{ badgeError }}</small>
      }
    </div>

  </form>

  <ng-template #footer>
    <div class="ef-dialog-footer mt-2">
      <p-button label="Cancel" variant="text" severity="secondary" size="small" (onClick)="cancel()" />
      <p-button [label]="isEditMode ? 'Save changes' : 'Create group'"
        [icon]="isEditMode ? '' : 'fa-solid fa-plus'"
        [loading]="loading || badgeLoading" severity="primary" size="small" (onClick)="submit()" />
    </div>
  </ng-template>

</p-dialog>
